import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * Parent chase ID reference.
 *
 * @remarks
 * System-managed UUID referencing the parent/primary move in a chase sequence.
 * Used in autoplanner for linking child moves to their parent.
 */
export const schema = z.string().uuid().optional();

export type ParentChaseId = z.infer<typeof schema>;

export const definition = define({
  key: 'parent_chase_id',
  schema,
  label: 'Parent Chase ID',
  description: 'UUID referencing the parent move in a chase sequence. Set by autoplanner, not user-configurable.',
  kind: DEFINITION_KINDS.OUTPUT,
  category: CATEGORIES.OPERATIONAL_STATE.key,
  writableAtLevels: [LEVELS.MOVE],
  readableByRoles: [ROLES.ADMIN],
});
